import { SalesRound } from '@/types/api/sale';

export const createRoundOption = (round: SalesRound) => ({
  value: round.id,
  label: new Date(round.cutoffAt).toLocaleDateString('sv-se'),
});
